import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
class CoreStore {
  constructor (options = {}) {
    this.options = options
    this.modules = {}
  }

  module (name, module) {
    this.modules[name] = module
  }

  store () {
    return new Vuex.Store(Object.assign({}, this.options, { modules: this.modules }))
  }
}

export default CoreStore
